module.exports = __webpack_public_path__ + "static/media/enhanced-grain-GoldenOak.614e66eb.png";